export default function Welcome(props) {

    return <div><h1>Welcome to Ghanem Forwarding!</h1></div>;
}